<template>
  <v-card flat>
    <v-card-text class="pa-5">
      <div class="d-md-flex align-items-center">
        <div>
          <h3 class="title font-weight-regular">Devices</h3>
          <h6 class="subtitle-2 font-weight-light">
            Different Devices Used to Visit
          </h6>
        </div>
      </div>
      <div
        v-if="isLoading"
        class="d-flex justify-center align-center"
        style="height:300px"
      >
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-if="!isLoading">
        <div v-show="elementVisible" class="pb-6">
          <vue-apex-charts
            type="donut"
            height="245"
            :options="donutChart.chartOptions"
            :series="donutChart.series"
          ></vue-apex-charts>
        </div>
        <v-divider></v-divider>
        <div class="d-md-flex align-center justify-center pt-4">
          <div class="d-flex align-center px-3 justify-center">
            <span class="info--text d-flex align-center">
              <span class="overline">
                <i class="fa fa-circle mr-2"></i>
              </span>
              <span class="font-weight-regular mr-1">Mobile</span>
            </span>
          </div>
          <div class="d-flex align-center px-3 justify-center">
            <span class="deep-purple--text text--lighten-1 d-flex align-center">
              <span class="overline">
                <i class="fa fa-circle mr-2"></i>
              </span>
              <span class="font-weight-regular mr-1">Desktop</span>
            </span>
          </div>
          <div class="d-flex align-center px-3 justify-center">
            <span class="success--text d-flex align-center">
              <span class="overline">
                <i class="fa fa-circle mr-2"></i>
              </span>
              <span class="font-weight-regular mr-1">Tablet</span>
            </span>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "TheOurVisitors",
  props: ["deviceRate"],
  data: () => ({
    isLoading: false,
    title: "TheOurVisitors",
    elementVisible: false,
    donutChart: {
      series: [50, 40, 30, 10],
      chartOptions: {
        labels: ["Mobile", "Tablet", "Other", "Desktop"],
        dataLabels: {
          enabled: false
        },
        grid: {
          padding: {
            left: 0,
            right: 0
          },
          borderColor: "rgba(0,0,0,0.5)"
        },
        plotOptions: {
          pie: {
            donut: {
              size: "86px",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "18px",
                  color: undefined,
                  offsetY: -10
                },
                value: {
                  show: true,
                  color: "#99abb4"
                },
                total: {
                  show: true,
                  label: "Our Visitors",
                  color: "#99abb4"
                }
              }
            }
          }
        },
        stroke: {
          width: 1,
          colors: "rgba(0,0,0,0.1)"
        },
        legend: {
          show: false
        },
        colors: ["#1e88e5", "#26c6da", "#eceff1", "#745af2"],
        tooltip: {
          fillSeriesColor: false
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                height: 250
              }
            }
          }
        ]
      }
    }
  }),
  created() {
    setTimeout(() => (this.elementVisible = true), 10);
  },
  components: {
    VueApexCharts
  },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  },
  watch: {
    deviceRate: async function(newVal) {
      this.isLoading = true;
      this.donutChart.series = [
        newVal[1].count,
        newVal[2].count,
        newVal[3].count,
        newVal[0].count
      ];
      await this.sleep(1000);

      this.isLoading = false;
    }
  },
  async mounted() {
    this.isLoading = true;
    while (!Array.isArray(this.deviceRate)) {
      await this.sleep(10);
    }
    this.donutChart.series = [
      this.deviceRate[1].count,
      this.deviceRate[2].count,
      this.deviceRate[3].count,
      this.deviceRate[0].count
    ];
    console.log(this.deviceRate);
    this.isLoading = false;
  }
};
</script>
<style scoped>
@media (min-width: 1264px) {
  .top-margin {
    margin-top: 30px;
  }
}
</style>
